var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generateKey-wrapper"},[_c('div',[_c('el-button',{attrs:{"type":"primary","loading":_vm.isLoading},on:{"click":function($event){return _vm.generateKey()}}},[_vm._v("生成密钥")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }